// Frontend environment configuration
export const env = {
  // App environment (development, staging, production)
  APP_ENV: (import.meta.env['VITE_APP_ENV'] || 'development') as 'development' | 'staging' | 'production',
  
  // API URL - defaults to localhost in development
  API_URL: import.meta.env['VITE_API_URL'] || 'http://localhost:4000',
  
  // Frontend URL - useful for redirects and absolute URLs
  FRONTEND_URL: import.meta.env['VITE_FRONTEND_URL'] || 'http://localhost:5173',
  
  // Derived environment checks
  get isDevelopment() {
    return this.APP_ENV === 'development';
  },
  
  get isStaging() {
    return this.APP_ENV === 'staging';
  },
  
  get isProduction() {
    return this.APP_ENV === 'production';
  },
  
  // Security settings based on environment
  get enableDevTools() {
    return this.isDevelopment;
  },
  
  get enableDebugLogging() {
    return this.isDevelopment || this.isStaging;
  }
};

// Validate environment on load
if (env.isProduction && env.API_URL.includes('localhost')) {
  console.warn('⚠️ Production environment detected but API_URL points to localhost');
}

if (env.isStaging && env.API_URL.includes('localhost')) {
  console.warn('⚠️ Staging environment detected but API_URL points to localhost');
}

// Environment validation only - no logging 